import { render, staticRenderFns } from "./CadastrosIndividuais.vue?vue&type=template&id=6f557267&scoped=true"
import script from "./CadastrosIndividuais.vue?vue&type=script&lang=js"
export * from "./CadastrosIndividuais.vue?vue&type=script&lang=js"
import style0 from "./CadastrosIndividuais.vue?vue&type=style&index=0&id=6f557267&prod&lang=css"
import style1 from "./styles.scss?vue&type=style&index=1&id=6f557267&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f557267",
  null
  
)

export default component.exports